module.exports = __webpack_public_path__ + "img/Slide31.26ed2b59.png";